"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommissionableServiceType = void 0;
var CommissionableServiceType;
(function (CommissionableServiceType) {
    CommissionableServiceType["SPECIAL"] = "SPECIAL";
    CommissionableServiceType["REGULAR"] = "REGULAR";
    CommissionableServiceType["REDUCED"] = "REDUCED";
})(CommissionableServiceType || (exports.CommissionableServiceType = CommissionableServiceType = {}));
